const cards = [
  {
    title: '国产古装剧精选',
    desc: '从《甄嬛传》到《长相思》，经典与热播一网打尽，服化道精良、剧情跌宕的古装大戏你最喜欢哪一部？',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20visual%20with%20traditional%20hanfu%20robes%20in%20rich%20red%20and%20gold%2C%20ancient%20Chinese%20architecture%20background%2C%20cinematic%20lighting%20with%20warm%20amber%20tones%2C%20elegant%20and%20majestic%20composition&width=800&height=560&seq=card-01&orientation=landscape',
    tag: '古装大戏',
    count: '200+部',
  },
  {
    title: '韩剧高清专区',
    desc: '热门韩剧同步更新，精准中文字幕翻译，浪漫爱情、悬疑惊悚、治愈生活，每一部都值得追看。',
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20scene%20with%20couple%20in%20autumn%20park%2C%20warm%20golden%20sunlight%20through%20trees%2C%20emotional%20and%20tender%20atmosphere%2C%20soft%20focus%20cinematic%20style%2C%20cozy%20aesthetic&width=800&height=560&seq=card-02&orientation=landscape',
    tag: '韩剧热播',
    count: '150+部',
  },
  {
    title: '高分悬疑推理',
    desc: '豆瓣高分悬疑剧合集，《隐秘的角落》《漫长的季节》等口碑神作，烧脑剧情让人欲罢不能。',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20and%20suspenseful%20atmosphere%20with%20dimly%20lit%20alleyway%20at%20night%2C%20single%20streetlamp%20casting%20dramatic%20shadows%2C%20noir%20cinematic%20style%20with%20deep%20blues%20and%20warm%20accents%2C%20intriguing%20composition&width=800&height=560&seq=card-03&orientation=landscape',
    tag: '悬疑烧脑',
    count: '80+部',
  },
  {
    title: '都市情感剧场',
    desc: '职场、爱情、家庭，都市生活的百味人生。《你比星光美丽》《繁花》带你感受当代都市的温度。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20sunset%20with%20warm%20golden%20light%2C%20contemporary%20office%20building%20windows%20reflecting%20light%2C%20urban%20lifestyle%20aesthetic%2C%20cinematic%20wide%20shot%2C%20elegant%20atmosphere&width=800&height=560&seq=card-04&orientation=landscape',
    tag: '都市情感',
    count: '180+部',
  },
  {
    title: '仙侠奇幻世界',
    desc: '从《花千骨》到《与凤行》，仙魔大战、三界纷争，视觉特效拉满的东方奇幻史诗等你来探索。',
    img: 'https://readdy.ai/api/search-image?query=Ethereal%20fantasy%20landscape%20with%20floating%20mountains%20and%20waterfalls%2C%20magical%20golden%20light%20particles%2C%20mythological%20Chinese%20celestial%20realm%2C%20dreamlike%20atmosphere%20with%20soft%20pearly%20tones%2C%20majestic%20scenery&width=800&height=560&seq=card-05&orientation=landscape',
    tag: '仙侠奇幻',
    count: '120+部',
  },
  {
    title: '年代经典回顾',
    desc: '《琅琊榜》《父母爱情》等年代经典作品高清修复，那些感动过无数人的好剧值得再次重温。',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20vintage%20Chinese%20setting%20with%20old%20wooden%20furniture%20and%20warm%20sunlight%20through%20window%2C%20retro%20atmosphere%20with%20sepia%20tones%2C%20classic%20elegance%2C%20timeless%20aesthetic%2C%20soft%20natural%20lighting&width=800&height=560&seq=card-06&orientation=landscape',
    tag: '经典重温',
    count: '100+部',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="relative py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
            <i className="ri-layout-grid-line text-primary-400 text-xs"></i>
            <span className="text-primary-300 text-xs font-medium">精选推荐</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            按类型 · 选好剧
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            六大题材分类精选，总有一种类型适合你的口味
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, i) => (
            <div
              key={i}
              className="group relative rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={card.img}
                  alt={`6080新视觉影视 ${card.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-lg bg-background-950/70 backdrop-blur-sm text-background-50 text-[10px] font-medium">
                    {card.count}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded-md bg-primary-50 text-primary-600 text-[10px] font-bold">
                    {card.tag}
                  </span>
                </div>
                <h3 className="font-heading font-bold text-base md:text-lg text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}